"use strict";
// 1. Отримуємо список за тегом 'ul' (бо класу .list в HTML немає)
var list = document.querySelector("ul");
/**
 * Допоміжна функція для очищення рядка від '$' та ',' і перетворення в число
 */ var toNum = function(value) {
    if (!value) return 0;
    // Видаляємо все, що не є цифрою (символи $ та коми)
    var cleanValue = value.replace(/[$,]/g, "");
    return Number(cleanValue) || 0;
};
/**
 * Сортує елементи за зарплатою у порядку спадання
 */ function sortList(listElement) {
    if (!listElement) return;
    var items = Array.from(listElement.children);
    items.sort(function(a, b) {
        var salaryA = toNum(a.dataset.salary);
        var salaryB = toNum(b.dataset.salary);
        return salaryB - salaryA;
    });
    // Очищаємо і додаємо відсортовані li
    listElement.innerHTML = "";
    items.forEach(function(item) {
        listElement.append(item);
    });
}
/**
 * Повертає масив об'єктів працівників
 */ function getEmployees(listElement) {
    if (!listElement) return [];
    return Array.from(listElement.children).map(function(item) {
        return {
            name: item.textContent.trim(),
            position: item.dataset.position,
            salary: toNum(item.dataset.salary),
            age: toNum(item.dataset.age)
        };
    });
}
// Виклик функцій
sortList(list);
getEmployees(list);

//# sourceMappingURL=index.f2d43df1.js.map
